import { render, staticRenderFns } from "./CouponModal.vue?vue&type=template&id=53bfe574&scoped=true"
import script from "./CouponModal.vue?vue&type=script&lang=js"
export * from "./CouponModal.vue?vue&type=script&lang=js"
import style0 from "./CouponModal.vue?vue&type=style&index=0&id=53bfe574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bfe574",
  null
  
)

export default component.exports